import { render, staticRenderFns } from "./FrPrivacyPolicy.vue?vue&type=template&id=27cb21ba&scoped=true"
import script from "./FrPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./FrPrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "27cb21ba",
  null
  ,true
)

export default component.exports